<template>
  <skeleton>
    <div class="w-full aspect-16-9"></div>
    <div class="w-full h-16"></div>
  </skeleton>
</template>

<script>
import Skeleton from "../components/Skeleton/index.vue";

export default {
  name: "AnimeActorCardSkeleton",
  components: {
    Skeleton,
  },
};
</script>

<style>
</style>